"use strict";
var __makeTemplateObject = (this && this.__makeTemplateObject) || function (cooked, raw) {
    if (Object.defineProperty) { Object.defineProperty(cooked, "raw", { value: raw }); } else { cooked.raw = raw; }
    return cooked;
};
Object.defineProperty(exports, "__esModule", { value: true });
exports.GET_IMAGE_IDS_BY_USER = void 0;
var client_1 = require("@apollo/client");
exports.GET_IMAGE_IDS_BY_USER = (0, client_1.gql)(templateObject_1 || (templateObject_1 = __makeTemplateObject(["\n  query GetImageIdsByUser($email: String!) {\n    imageIdsByUser(email: $email) {\n      results\n    }\n  }\n"], ["\n  query GetImageIdsByUser($email: String!) {\n    imageIdsByUser(email: $email) {\n      results\n    }\n  }\n"])));
var templateObject_1;
